import { Flex, layout, styled, Span } from '@fareye/ui'
import {
  capitalize,
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryQuarter,
  FaBatteryThreeQuarters,
  FaSignal,
  formatMs,
  hhmmADoMMMYYYY,
  MdPerson,
  pascalCase,
  getValueFromNestedKey,
  formatters
} from '@fareye/utils'
import React from 'react'
import { stateColorOption, statusColorOption } from '@fareye/configs'
// import useWindowDimensions from '../../hooks/useWindowDimensions'
import { HideSlug, RWDLabel, RWDLink, RWDSpan } from '../../style/styled'
import { StoryLine } from './components/StoryLine'
interface IHeader {
  align?: 'left' | 'right' | 'center'
}

const Fa: any = {
  FaBatteryEmpty,
  FaBatteryFull,
  FaBatteryQuarter,
  FaBatteryThreeQuarters
}

const stringtoReactIconName = (name: string) =>
  name
    .split('-')
    .map(item => capitalize(item))
    .join('')

const regex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/

const ColFullHeight = styled((props: any) => (
  <Flex
    p={2}
    justifyContentSpaceEvenly
    column
    {...props}
    style={{
      height: '100%',
      overflow: 'hidden',
      paddingLeft: 8,
      ...props.style
    }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`
const FullHeight = styled((props: any) => (
  <Flex
    p={2}
    alignItemsCenter
    {...props}
    style={{ height: '100%', overflow: 'hidden', ...props.style }}
  >
    {props.children}
  </Flex>
))`
  ${layout}
`

const Header = styled(RWDSpan)`
  width: 100%;
  display: block;
  text-transform: uppercase;
  padding: 6px 2px 6px 4px;
  text-align: ${(props: any) => (props.isNumeric ? 'right' : 'left')};
`

function generateColumnObject(ele: any, { t, links, queryParams }: any) {
  const { width } = window.screen
  const { label, key, sortable, formatter } = ele
  switch (key) {
    case 'expand':
      return {
        Header: () => (
          <div style={{ padding: 0, display: 'none', margin: '0 -5px' }} />
        ),
        sortable: false,
        expander: true,
        width: 0,
        style: { padding: 0, display: 'none' },
        Expander: () => null
      }
    case 'expandHide':
      return {
        Header: () => (
          <div style={{ padding: 0, display: 'none', margin: '0 -5px' }} />
        ),
        show: false,
        sortable: false,
        expander: true,
        width: 0,
        style: { padding: 0, display: 'none' },
        Expander: () => null
      }
    case 'tripIdAndProduct':
      return {
        Header: t(label),
        sortable: false,
        accessor: 'referenceNo',
        width: 100,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
            <HideSlug data-key-id="slug">{original.slug}</HideSlug>
            <RWDLink
              target={width < 769 ? '_self' : '_blank'}
              variant="xs"
              to={`${links.tripShare}/${original.slug}${queryParams.tripShare ||
                ''}`}
            >
              {original.referenceNo || '-'}
            </RWDLink>
            {!!original.material && original.material !== 'N.A' ? (
              <RWDLabel variant="secondary" style={{ fontWeight: 600 }}>
                {original.material}
              </RWDLabel>
            ) : null}
          </ColFullHeight>
        )
      }
    case 'routeDetails':
      return {
        Header: t(label),
        width: 70,
        sortable: false,
        Cell: ({ row: { original } }: any) =>
          original.origin && original.destination ? (
            <ColFullHeight justifyContentSpaceEvenly>
              <RWDSpan color="#006491">
                {original.origin ? original.origin.toUpperCase() : ''}
              </RWDSpan>
              <RWDSpan color="#006491">
                {original.destination ? original.destination.toUpperCase() : ''}
              </RWDSpan>
            </ColFullHeight>
          ) : null
      }
    case 'tripID':
      return {
        Header: t(label),
        sortable: true,
        id: 'referenceNo',
        accessor: 'referenceNo',
        width: 120,
        Cell: ({ row: { original } }: any) => (
          <FullHeight data-id="referenceNo">
            <HideSlug>{original.slug}</HideSlug>
            <RWDLink
              target={width < 769 ? '_self' : '_blank'}
              variant="xs"
              to={`${links.tripShare}/${original.slug}${queryParams.tripShare ||
                ''}`}
            >
              {original.referenceNo || '-'}
            </RWDLink>
          </FullHeight>
        )
      }
    case 'startTimeAndSTA':
      return {
        Header: t(label),
        sortable: true,
        accessor: 'startTimeAndSTA',
        width: 120,
        Cell: ({ row: { original } }: any) => {
          const datesArray = [
            original.startDate ? hhmmADoMMMYYYY(original.startDate) : '-',
            original.sta ? hhmmADoMMMYYYY(original.sta) : '-'
          ]
          return (
            <ColFullHeight data-id="startDate-sta" justifyContentCenter>
              <StoryLine dataSet={datesArray} />
            </ColFullHeight>
          )
        }
      }
    case 'transitTimeETA':
      return {
        Header: t(label),
        sortable: false,
        width: 110,
        Cell: ({ row: { original } }: any) => {
          const statusColor: any = {
            ...statusColorOption
          }
          //delayed,early,ontime,unknown changed
          return (
            <ColFullHeight alignItemsFlexStart style={{ padding: 4 }}>
              {original.status ? (
                <RWDSpan
                  variant="h6"
                  style={{
                    padding: '2px 5px',
                    marginBottom: 4,
                    background: original.status
                      ? statusColor[original.status.toLowerCase()]
                        ? statusColor[original.status.toLowerCase()]
                        : '#ffd740'
                      : '',
                    color: '#fff',
                    borderRadius: 2
                  }}
                >
                  {t(pascalCase(original.status))}
                  {original.statusTimeDiff
                    ? ` ${t('by')} ${formatMs(original.statusTimeDiff)}`
                    : null}
                </RWDSpan>
              ) : null}
              <RWDSpan mb={1} color="#555">
                {`${t('Target')} - ${formatMs(
                  Number(original.targetTransitTime)
                )}`}
              </RWDSpan>
              {original.ata ? null : (
                <RWDSpan color="#555">
                  {`${t('Running Since')} ${formatMs(
                    Number(original.actualTransitTime)
                  )}`}
                </RWDSpan>
              )}
            </ColFullHeight>
          )
        }
      }
    case 'eta':
      return {
        Header: t(label),
        sortable: true,
        accessor: 'eta',
        width: 80,
        Cell: ({ row: { original } }: any) => {
          let tempTime = original.ata || original.rtEta || original.eta
          let formattedTime = tempTime
            ? hhmmADoMMMYYYY(tempTime).split(' | ')
            : ['', '']
          return (
            <ColFullHeight data-id="ata|rtEta|eta">
              <RWDSpan
                variant="h6"
                style={{ fontWeight: 600, color: '#525252' }}
              >
                {formattedTime[1]}
              </RWDSpan>
              <RWDSpan
                variant="h6"
                style={{ fontWeight: 600, color: '#525252' }}
              >
                {formattedTime[0]}
              </RWDSpan>
            </ColFullHeight>
          )
        }
      }
    case 'exceptions':
      return {
        Header: t(label),
        sortable: true,
        accessor: 'exceptionsCount',
        width: 60,
        Cell: ({ row: { original } }: any) => (
          <FullHeight justifyContentCenter>
            <RWDLink
              target={width < 769 ? '_self' : '_blank'}
              to={`${links.tripShare}/${original.slug}?tab=${'exceptions'}`}
            >
              <RWDLabel
                variant={`${original.exceptionsCount ? 'danger' : 'secondary'}`}
                style={{ cursor: 'pointer' }}
              >
                {original.exceptionsCount || 0}
              </RWDLabel>
            </RWDLink>
          </FullHeight>
        )
      }
    case 'landmarkEta':
      return {
        Header: t(label),
        sortable: false,
        width: 150,
        Cell: ({ row: { original } }: any) => {
          return (
            <ColFullHeight>
              <RWDSpan
                style={{ height: 28, marginBottom: 5, whiteSpace: 'normal' }}
                variant="ellipsis"
              >
                {original.currLocation ? original.currLocation.landmark : '-'}
              </RWDSpan>
              {/* <RWDSpan>Last Updated At: </RWDSpan> */}
              <RWDSpan>
                {original.currLocation
                  ? hhmmADoMMMYYYY(original.currLocation.istTimestamp)
                  : '-'}
              </RWDSpan>
            </ColFullHeight>
          )
        }
      }
    case 'tripCompletion':
      return {
        Header: t(label),
        sortable: true,
        width: 75,
        accessor: 'tripCompletion',
        Cell: ({ row: { original } }: any) => (
          <FullHeight justifyContentCenter>
            <RWDSpan variant="h6">
              {original.tripCompletionPerc
                ? `${
                    original.tripCompletionPerc.toString().includes('.')
                      ? original.tripCompletionPerc.toFixed('2')
                      : original.tripCompletionPerc
                  }%`
                : '-'}
            </RWDSpan>
          </FullHeight>
        )
      }
    case 'driverDetailsETA':
      return {
        Header: t(label),
        sortable: false,
        accessor: 'driverDetailsETA',
        width: 190,
        Cell: ({ row: { original } }: any) => {
          const Icon =
            original.deviceInfo &&
            Fa[stringtoReactIconName(original.deviceInfo.batteryStrength.icon)]
          return original.origin && original.destination ? (
            <FullHeight
              justifyContentSpaceBetween
              style={{ background: 'rgba(230,233,236,0.5)' }}
            >
              <Flex style={{ width: 150 }}>
                <MdPerson
                  style={{
                    margin: 5,
                    background: '#d1d1d2',
                    borderRadius: '50%',
                    height: '20px',
                    width: '20px'
                  }}
                />
                <Flex column style={{ width: 120, textAlign: 'left' }}>
                  <RWDSpan mb={1} variant="primary">
                    {original.driverName}
                  </RWDSpan>
                  <RWDSpan
                    mb={1}
                    variant="secondary"
                    style={{ fontWeight: 'normal' }}
                  >
                    {original.vehicleNo}
                  </RWDSpan>
                  <RWDLabel
                    variant="secondary ellipsis"
                    style={{ fontWeight: 600, maxWidth: '150px' }}
                  >
                    {original.transporter}
                  </RWDLabel>
                </Flex>
              </Flex>
              {original.deviceInfo ? (
                <ColFullHeight style={{ width: 60, paddingLeft: 5 }}>
                  <Flex alignItemsCenter>
                    <RWDSpan
                      style={{
                        transform: 'rotate(-90deg)',
                        paddingLeft: '5px',
                        borderLeft: '1px solid #d8d8d8'
                      }}
                      title={
                        ['Good', 'Average'].includes(
                          original.deviceInfo.batteryStrength.status
                        )
                          ? t('Good')
                          : t('Poor')
                      }
                    >
                      <Icon
                        color={
                          ['Good', 'Average'].includes(
                            original.deviceInfo.batteryStrength.status
                          )
                            ? '#7dd321'
                            : 'e20a0a'
                        }
                      />
                    </RWDSpan>
                    <RWDSpan>
                      {['Good', 'Average'].includes(
                        original.deviceInfo.batteryStrength.status
                      )
                        ? t('Good')
                        : t('Poor')}
                    </RWDSpan>
                  </Flex>
                  <Flex style={{ paddingTop: 5 }} alignItemsCenter>
                    <RWDSpan
                      color={
                        original.deviceInfo.signalStrength.status === 'Good'
                          ? '#7dd321'
                          : '#e20a0a'
                      }
                      title={
                        original.deviceInfo.signalStrength.status === 'Good'
                          ? t('Good')
                          : t('Poor')
                      }
                    >
                      <FaSignal />
                    </RWDSpan>
                    <RWDSpan style={{ paddingLeft: 5 }}>
                      {original.deviceInfo.signalStrength.status === 'Good'
                        ? t('Good')
                        : t('Poor')}
                    </RWDSpan>
                  </Flex>
                </ColFullHeight>
              ) : null}
            </FullHeight>
          ) : null
        }
      }
    case 'landmark':
      return {
        Header: t(label),
        sortable: false,
        width: 400,
        Cell: ({ row: { original } }: any) => {
          return (
            <FullHeight>
              <RWDSpan>
                {original.currLocation ? original.currLocation.landmark : '-'}
              </RWDSpan>
            </FullHeight>
          )
        }
      }
    case 'istTimestamp':
      return {
        Header: t(label),
        sortable: true,
        width: 160,
        accessor: 'istTimestamp',
        Cell: ({ row: { original } }: any) => {
          return (
            <FullHeight>
              <RWDSpan>
                {original.currLocation
                  ? hhmmADoMMMYYYY(original.currLocation.istTimestamp)
                  : '-'}
              </RWDSpan>
            </FullHeight>
          )
        }
      }
    case 'etaList':
      return {
        Header: t(label),
        sortable: true,
        accessor: 'eta',
        width: 160,
        Cell: ({ row: { original } }: any) => (
          <FullHeight>
            <RWDSpan>{hhmmADoMMMYYYY(original.rtEta || original.eta)}</RWDSpan>
          </FullHeight>
        )
      }
    case 'battery':
      return {
        Header: t(label),
        sortable: false,
        width: 70,
        Cell: ({ row: { original } }: any) => {
          const { status } = original?.deviceInfo?.batteryStrength || {}
          return (
            <FullHeight>
              <RWDSpan>{t(status) || '-'}</RWDSpan>
            </FullHeight>
          )
        }
      }
    case 'signalStrength':
      return {
        Header: t(label),
        sortable: false,
        width: 135,
        Cell: ({ row: { original } }: any) => {
          const { status } = original?.deviceInfo?.signalStrength || {}
          return (
            <FullHeight>
              <RWDSpan>{t(status) || '-'}</RWDSpan>
            </FullHeight>
          )
        }
      }
    case 'startAndEndTime':
      return {
        Header: t(label),
        sortable: true,
        accessor: 'startDate',
        width: 220,
        Cell: ({ row: { original } }: any) => {
          const datesArray = [
            original.loadingOutTime
              ? hhmmADoMMMYYYY(original.loadingOutTime)
              : '-',
            original.unloadingInTime
              ? hhmmADoMMMYYYY(original.unloadingInTime)
              : '-'
          ]
          return (
            <ColFullHeight justifyContentCenter>
              {original.loadingOutTime || original.unloadingInTime ? (
                <StoryLine dataSet={datesArray} />
              ) : null}
            </ColFullHeight>
          )
        }
      }
    case 'transitTime':
      return {
        Header: t(label),
        sortable: false,
        width: 120,
        Cell: ({ row: { original } }: any) => {
          const statusColor: any = {
            ...statusColorOption,
            ...stateColorOption
          }
          // changed delayed,early,ontime,unknown
          return (
            <ColFullHeight>
              <RWDSpan
                variant="h6"
                color={`${
                  original.status
                    ? statusColor[original.status.toLowerCase()]
                      ? statusColor[original.status.toLowerCase()]
                      : '#ffd740'
                    : ''
                }`}
              >
                {original.status ? t(pascalCase(original.status)) : ''}
              </RWDSpan>
              <RWDSpan mb={1} color="#727272">
                {`${t('Target')} - ${formatMs(
                  Number(original.targetTransitTime)
                )}`}
              </RWDSpan>
              <RWDSpan mb={1} color="#727272">
                {!original.isActive
                  ? `${t('Actual')} - ${formatMs(
                      Number(original.actualTransitTime)
                    )}`
                  : original.tripCompletionPerc &&
                    `% ${t(
                      'Completed'
                    )} - ${original.tripCompletionPerc.toFixed(0)}%`}
              </RWDSpan>
            </ColFullHeight>
          )
        }
      }
    case 'driverDetails':
      return {
        Header: t(label),
        width: 200,
        sortable: false,
        Cell: ({ row: { original } }: any) =>
          original.transporter ? (
            <FullHeight style={{ background: 'rgba(230,233,236,0.5)' }}>
              <MdPerson
                style={{
                  margin: '5px 10px 5px 10px',
                  background: '#d1d1d2',
                  borderRadius: '50%',
                  height: '23px',
                  width: '23px'
                }}
              />
              <Flex column style={{ textAlign: 'left', flexGrow: 1 }}>
                <RWDSpan variant="primary">{original.driverName}</RWDSpan>
                <RWDSpan variant="secondary">{original.vehicleNo}</RWDSpan>
                <RWDLabel
                  variant="secondary ellipsis"
                  style={{ fontWeight: 600, maxWidth: '250px' }}
                >
                  {original.transporter}
                </RWDLabel>
              </Flex>
            </FullHeight>
          ) : null
      }
    case 'vivo':
      return {
        Header: t(label),
        sortable: false,
        width: 90,
        Cell: ({ row: { original } }: any) => (
          <FullHeight>
            {original.loadingOutTime && original.loadingInTime
              ? formatMs(
                  Number(
                    new Date(original.loadingOutTime).getTime() -
                      new Date(original.loadingInTime).getTime()
                  )
                )
              : '-'}
          </FullHeight>
        )
      }
    case 'plantInOut':
      return {
        Header: t(label),
        sortable: false,
        accessor: 'gateIn',
        width: 220,
        Cell: ({ row: { original } }: any) => {
          const datesArray = [
            original.loadingInTime
              ? hhmmADoMMMYYYY(original.loadingInTime)
              : '-',
            original.loadingOutTime
              ? hhmmADoMMMYYYY(original.loadingOutTime)
              : '-'
          ]
          return (
            <ColFullHeight justifyContentCenter>
              {original.loadingInTime || original.loadingOutTime ? (
                <StoryLine dataSet={datesArray} />
              ) : null}
            </ColFullHeight>
          )
        }
      }
    case 'vehicleState':
      return {
        Header: t(label),
        sortable: false,
        width: 150,
        Cell: ({ row: { original } }: any) => {
          const { state } =
            (original.deviceInfo && original.deviceInfo.vehicleState) || {}
          return (
            <FullHeight>
              <RWDSpan>{!state ? '-' : t(state)}</RWDSpan>
            </FullHeight>
          )
        }
      }

    case 'driverLicenceUrl':
    case 'vehicleRcUrl':
      return {
        Header: () => <Header data-id={key}>{t(label)}</Header>,
        id: key,
        width: 180,
        Cell: ({ row: { original } }: any) => {
          const value = original?.[key]
          return (
            <ColFullHeight>
              {regex.test(value) ? (
                <a
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Click here to open"
                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff' }}
                >
                  {key === 'driverLicenceUrl' ? 'View Licence' : 'View Vehicle RC'}
                </a>
              ) : (
                <Span>-</Span>
              )}
            </ColFullHeight>
          )
        }
      }
      
    default:
      return {
        Header: t(label),
        width: 140,
        sortable: sortable ? sortable : true,
        accessor: key,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight>
              <RWDSpan variant="ellipsis">
                {formatter && (formatters as any)[formatter]
                  ? (formatters as any)[formatter](value) || '-'
                  : value || (value === 0 ? 0 : '-')}
              </RWDSpan>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: any[],
  { t, links, queryParams }: any
) {
  const result: any = []
  reqdColumns?.map((ele: any) => {
    if (ele.key && !['expand', 'expandHide'].includes(ele.key)) {
      const processedColumns = generateColumnObject(ele, {
        t,
        links,
        queryParams
      })
      result.push({
        ...processedColumns,
        id: processedColumns.id || ele.key
      })
    }
  })
  return result
}
